<template>
  <v-dialog v-model="show2" content-class="dialog-fixed-size dialog-small"
    @keydown.esc.stop="closeDialog" @click.prevent.stop="closeDialog"
    @keydown.enter.stop="validateForm">
    <v-card>
      <v-card-title>
        <h1 class="secondary--text">{{ $t('LBL.LOG_IN') }}</h1>
        <v-spacer></v-spacer>
        <v-icon dark color="secondary">face</v-icon>
      </v-card-title>
      <v-card-text>

        <v-form v-model="formValid" ref="loginForm">
          <v-text-field name="loginEmail" id="loginEmail" required :label="$t('LBL.EMAIL')"
            autocomplete="username"
            v-model="loginEmail" :rules="emailRules"
          ></v-text-field>
          <v-text-field type="password" id="loginPassword" name="loginPassword" required
            :label="$t('LBL.PASSWORD')" autocomplete="current-password"
            v-model="loginPassword" :rules="passwordRules"
          ></v-text-field>
        </v-form>

        <div>
          <a class="secondary--text" @click="closeDialog('password-reset')">{{ $t('LBL.MSG_FORGOT_PASSWORD') }}</a>
        </div>
      </v-card-text>
      <v-card-actions class="primary">
        <v-btn flat dark @click.stop="closeDialog('register')" :disabled="loading">{{ $t('LBL.REGISTER') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn flat dark @click.stop="closeDialog" :disabled="loading">{{ $t('LBL.CANCEL') }}</v-btn>
        <v-btn flat dark @click.stop="validateForm" :loading="loading" :disabled="loading">{{ $t('LBL.LOG_IN') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ServerErrorMixin from '@/components/mixins/ServerErrorMixin'
import { ENQUEUE_SNACKBAR } from '@/store/mutation-types'

export default {
  name: 'LoginDialog',
  computed: {
    ...mapGetters([
      'userLanguage'
    ])
  },
  data () {
    return {
      emailRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.EMAIL')}),
        v => /^\w+([.-]?\w+)*([+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$i18n.t('RULE.FIELD_INVALID_VALUE', {FIELD: this.$i18n.t('LBL.EMAIL')})
      ],
      passwordRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.PASSWORD')}),
        v => (!!v && v.length >= 4) || this.$i18n.t('RULE.FIELD_MIN_LENGTH', {FIELD: this.$i18n.t('LBL.PASSWORD'), FIELD_LEN: '4 ' + this.$i18n.t('LBL.CHARACTERS')})
      ],
      formValid: null,
      loginEmail: '',
      loginPassword: '',
      show2: false,
      loading: false
    }
  },
  methods: {
    validateForm () {
      if (this.$refs.loginForm.validate()) {
        const data = {
          email: this.loginEmail,
          password: this.loginPassword,
          language: this.userLanguage
        }

        if (this.loading) {
          return
        }

        this.loading = true

        this.doLogin(data)
          .then(() => {
            this.$router.push('/home')
            this.showMessage({
              text: this.$root.$i18n.t('MSG.LOGIN_SUCCESS'),
              color: 'success'
            })
          })
          .catch((error) => {
            this.showMessage({
              text: this.$i18n.t(this.getErrorMessage(error) || 'MSG.SYSTEM_ERROR_RETRY'),
              color: 'error'
            })
          })
          .finally(() => { this.loading = false })
      }
    },
    closeDialog (action) {
      if (action === 'register') {
        this.$emit('click-register')
      } else if (action === 'password-reset') {
        this.$emit('click-password-reset')
      }

      this.show2 = false
    },
    ...mapActions({
      doLogin: 'login'
    }),
    ...mapMutations({
      showMessage: ENQUEUE_SNACKBAR
    })
  },
  mixins: [
    ServerErrorMixin
  ],
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show (val) {
      this.show2 = val
    },
    show2 (val) {
      if (this.show2 !== this.show) {
        this.$emit('update:show', this.show2)
      }

      if (!val) {
        Vue.nextTick(() => {
          this.$refs.loginForm.reset()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dialogs/LoginDialog.vue